import { render } from "./forgot-password2.vue?vue&type=template&id=421b7983"
import script from "./forgot-password2.vue?vue&type=script&lang=js"
export * from "./forgot-password2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__